export function buildTenantUrl(path, identity) {
    let url = path.startsWith("/") ? path.substring(1) : path;
    if (identity && !!identity.shopId && !!identity.tenantId) {
        return `/${identity.shopId}/${identity.tenantId}/${url}`;
    }
    return `/${url}`;
}
export function formatMenuLinks(items, shopId, tenantId) {
    return items.map((item) => {
        const formatted = { ...item };
        if (item.link) {
            formatted.link = buildTenantUrl(item.link, {
                shopId: shopId,
                tenantId: tenantId,
            });
        }
        if (item.listChild?.length) {
            formatted.listChild = formatMenuLinks(item.listChild, shopId, tenantId);
        }
        return formatted;
    });
}
//# sourceMappingURL=tenant-url.js.map